import fetchMock from 'jest-fetch-mock';
import { ProjectsRepository } from './ProjectsRepository';
import { workflowFactory } from '../../workflows/__tests__/factories';
import { dev } from '../../configs';
import { Project } from '..';
import { SessionManager } from '../../tracking';

beforeEach(() => {
  fetchMock.doMock();
});

describe('ProjectsRepository', () => {
  let repository: ProjectsRepository;

  beforeEach(() => {
    fetchMock.resetMocks();
    const sessionManager = new SessionManager('test');
    repository = new ProjectsRepository(dev, sessionManager);
  });

  describe('getClientProjectById', () => {
    describe('when retrieving client project fails', () => {
      beforeEach(() => {
        fetchMock.mockRejectOnce(new Error('some error'));
      });
      it('should throw an error', async () => {
        await expect(repository.getClientProjectByEnvironmentId('1234')).rejects.toThrow('some error');
      });
    });
    describe('when retrieving client project is successful', () => {
      const data: Project = {
        envId: '1234',
        projectId: '5678',
        orgId: '9012',
        workflows: workflowFactory.buildList(2)
      };
      beforeEach(() => {
        fetchMock.mockResponseOnce(JSON.stringify(data));
      });
      it('should return the client project', async () => {
        const res = await repository.getClientProjectByEnvironmentId('1234');
        expect(res).toEqual(data);
      });
    });
  });
});
